<template>
    <div class="listing-select" v-click-outside="close">
        <!-- LOADER -->
        <preloader :display="loading" size="small"/>

        <!-- SELECTED VALUE -->
        <div class="selectedLabel p-2 flex-level" :class="{'cpointer' :route && permission}" @click="openDropdown">
            <chip-label
                :color = selected.color
                :label = selected.label />
            <i class="el-icon-arrow-down gray-60 ml-2 flex-item-right" v-if="route && permission"></i>
        </div>
        
        <!-- OPEN DROPDOWN -->
        <ul v-if="open" class="itemsSelector pabsolute top-left zi-1 mw-100pc b-0 shadow white-bkg m-0 px-0">
            <li class="selectedItem py-2 cpointer bb-1 flex-level" @click="close">
                <chip-label
                    :color = selected.color
                    :label = selected.label />
                <i class="el-icon-arrow-up gray-60 flex-item-right ml-2" v-if="route"></i>
            </li>
            <li class="py-2 cpointer flex-level" v-for="item in availableItems" @click="setSelected(item)" :key="item.id">
                <chip-label
                    :color = item.color
                    :label = item.label />
            </li>
        </ul>
    </div>
</template>

<script>

    import Preloader from "vcomponents/utilities/Preloader.vue";
    import ChipLabel from 'vcomponents/utilities/ChipLabel.vue';

    export default {

        props: {
            items: {
                type : Array,
                required : true
            },
            route: {
                type: String,
                required: true
            },
            routeParam: {
                type: String,
                required: false
            },
            permission: {
                type: Boolean,
                required: false,
                default: true
            },
        },

        data : function(){
            return {
                open : false,
                loading:false,
                selected: {}
            }
        },
        created(){
            this.updateSelected(this.items)
        },
        computed: {
            availableItems () {
                return this.items.filter(item => !item.selected)
            },
            hasDropdown() {
                return (this.route !== '') && this.permission
            }
        },
        methods: {
            updateSelected(list) {
                this.selected = list.find(item => item.selected)
                if (!this.selected){
                    this.selected = {
                        id :    '',
                        label : '',
                        color : ''
                    }
                }
            },

            close() {
                this.open = false
            },

            openDropdown() {
                if (this.hasDropdown) {
                    this.open = true
                }
            },

            setSelected(chosenItem) {
                this.loading = true
                this.close()
                this.$ajax.put(this.route, {},
                    {
                        "value" : chosenItem.id,
                        "field" : this.routeParam,
                    },
                    (response) => {
                        this.selected = chosenItem
                        this.loading = false
                        this.$emit('emitSuccess',chosenItem, response)
                    },
                    (error) => {
                        Push.error(error)
                    }
                )
            }
        },
        watch: {
            items: {
                handler(val) {
                    this.updateSelected(val)
                },
                deep: true
            }
        },

        components: {
            Preloader,
            ChipLabel,
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@sellsy/styleguide/src/_variables';

    .itemsSelector{
        li {
            padding: 8px !important;
            &:hover{ background-color:$primary-05; }
        }
        max-height : 240px;
        overflow-y : scroll;
    }

    .selectedLabel{
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .el-table.table-condensed .selectedItem { padding: 4px 0; }
</style>
